/*
export function someMutation (state) {
}
*/


export function SET_RESULTADO(state, r) {
  state.resultado = r;
}
